<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section>
      <q-item-label>
        <span class="module-name q-mr-sm">
          <span v-if="item.code" class="text-weight-bolder">
            {{ truncateString(item.code, 10) }}
          </span>
          <span v-if="item.name" class="text-weight-medium">
            <template v-if="item.code">-</template> {{ item.name }}
          </span>
        </span>
      </q-item-label>
      <q-item-label
        v-if="item.description"
        caption
        class="text-ellipsis"
        :title="item.description"
      >
        {{ item.description }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      v-if="!simple"
      side
      class="text-bold"
      style="min-width: 100px;"
    >
      {{ baseUnitPriceStr(item) }}
    </q-item-section>
    <q-item-section
      v-if="!simple"
      side
      class="gt-xs"
    >
      <q-item-label caption>
        {{ type }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
    >
      <slot />
    </q-item-section>
  </q-item>
</template>

<script>
import inventoryMixin from './mixin'
import itemMixin from 'src/helpers/item'

export default {
  mixins: [itemMixin, inventoryMixin],
  props: {
    item: {
      required: true,
      type: Object
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    type () {
      return this.availableTypes().find(item => item.value === this.item.type).label
    }
  }
}
</script>
